module.exports = __webpack_public_path__ + "img/ColouredGel-StillLife.67dd7df8.jpeg";